import React from 'react';
import * as classes from './index.module.css'
import PropTypes from 'prop-types';

const DefaultLayout = ({children, ...props}) => {
    return (
        <div className={classes.root}>
            {children}
        </div>
    );
};

DefaultLayout.propTypes = {
    
};

export default DefaultLayout;